module.exports = __webpack_public_path__ + "static/media/editor-icon-text-style-active.048b0be4.svg";